var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCannedfood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "canned-food_2_",
    "data-name": "canned-food (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10882",
    "data-name": "Path 10882",
    d: "M272.484,22.223h23.541V69.709H272.484Zm0,0",
    transform: "translate(-244.81 -19.966)",
    fill: "#60d9fe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10883",
    "data-name": "Path 10883",
    d: "M473.367,22.223h3.139V69.709h-3.139Zm0,0",
    transform: "translate(-425.29 -19.966)",
    fill: "#40ccf7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10884",
    "data-name": "Path 10884",
    d: "M289.24,484.233H265.385a.627.627,0,0,1-.628-.628v-1.883a.628.628,0,0,1,.628-.628H289.24a.628.628,0,0,1,.628.628v1.883A.627.627,0,0,1,289.24,484.233Zm0,0",
    transform: "translate(-237.868 -432.232)",
    fill: "#d1ffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10885",
    "data-name": "Path 10885",
    d: "M289.24,3.139H265.385a.628.628,0,0,1-.628-.628V.628A.627.627,0,0,1,265.385,0H289.24a.627.627,0,0,1,.628.628V2.511A.628.628,0,0,1,289.24,3.139Zm0,0",
    transform: "translate(-237.868 0)",
    fill: "#d1ffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10886",
    "data-name": "Path 10886",
    d: "M328.145,144.934c0-6.934-3.466-12.555-7.742-12.555S312.66,138,312.66,144.934s3.466,12.555,7.743,12.555S328.145,151.868,328.145,144.934Zm0,0",
    transform: "translate(-280.905 -118.934)",
    fill: "#ffcd6b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10887",
    "data-name": "Path 10887",
    d: "M478.053,0h-3.139a.627.627,0,0,1,.628.628V2.511a.628.628,0,0,1-.628.628h3.139a.628.628,0,0,0,.628-.628V.628A.627.627,0,0,0,478.053,0Zm0,0",
    transform: "translate(-426.68 0)",
    fill: "#bbeded"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10888",
    "data-name": "Path 10888",
    d: "M478.053,481.094h-3.139a.628.628,0,0,1,.628.628v1.883a.627.627,0,0,1-.628.628h3.139a.627.627,0,0,0,.628-.628v-1.883A.628.628,0,0,0,478.053,481.094Zm0,0",
    transform: "translate(-426.68 -432.233)",
    fill: "#bbeded"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10889",
    "data-name": "Path 10889",
    d: "M72.59,116.41H93.415v16.765H72.59Zm0,0",
    transform: "translate(-65.217 -104.587)",
    fill: "#3bd387"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10890",
    "data-name": "Path 10890",
    d: "M246.727,116.41h3.139v16.765h-3.139Zm0,0",
    transform: "translate(-221.669 -104.587)",
    fill: "#37c487"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10891",
    "data-name": "Path 10891",
    d: "M134.721,205.537c0-3.64-2.284-6.592-5.1-6.592s-5.1,2.951-5.1,6.592,2.285,6.592,5.1,6.592S134.721,209.178,134.721,205.537Zm0,0",
    transform: "translate(-111.869 -178.74)",
    fill: "#ffcd6b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10892",
    "data-name": "Path 10892",
    d: "M84.575,99.189H62.913a.628.628,0,0,1-.628-.628V96.678a.628.628,0,0,1,.628-.628H84.575a.627.627,0,0,1,.628.628v1.883A.627.627,0,0,1,84.575,99.189Zm0,0",
    transform: "translate(-55.959 -86.295)",
    fill: "#d1ffff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10893",
    "data-name": "Path 10893",
    d: "M253.99,96.051h-3.139a.627.627,0,0,1,.628.628v1.883a.627.627,0,0,1-.628.628h3.139a.628.628,0,0,0,.628-.628V96.678A.628.628,0,0,0,253.99,96.051Zm0,0",
    transform: "translate(-225.374 -86.296)",
    fill: "#bbeded"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10894",
    "data-name": "Path 10894",
    d: "M10.3,293.086H42.735V313.07H10.3Zm0,0",
    transform: "translate(-9.255 -263.319)",
    fill: "#fe5555"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10895",
    "data-name": "Path 10895",
    d: "M298.754,293.086h3.139V313.07h-3.139Zm0,0",
    transform: "translate(-268.412 -263.319)",
    fill: "#e84141"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10896",
    "data-name": "Path 10896",
    d: "M33.9,484.233H.627A.627.627,0,0,1,0,483.605v-1.883a.628.628,0,0,1,.628-.628H33.9a.628.628,0,0,1,.628.628v1.883A.628.628,0,0,1,33.9,484.233Zm0,0",
    transform: "translate(0.001 -432.232)",
    fill: "#d1ffff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10897",
    "data-name": "Path 10897",
    d: "M33.9,274.077H.627A.628.628,0,0,1,0,273.449v-1.883a.627.627,0,0,1,.628-.628H33.9a.628.628,0,0,1,.628.628v1.883A.628.628,0,0,1,33.9,274.077Zm0,0",
    transform: "translate(0.001 -243.421)",
    fill: "#d1ffff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10898",
    "data-name": "Path 10898",
    d: "M306.013,481.094h-3.139a.628.628,0,0,1,.628.628v1.883a.627.627,0,0,1-.628.628h3.139a.628.628,0,0,0,.628-.628v-1.883A.628.628,0,0,0,306.013,481.094Zm0,0",
    transform: "translate(-272.114 -432.233)",
    fill: "#bbeded"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10899",
    "data-name": "Path 10899",
    d: "M306.013,270.938h-3.139a.627.627,0,0,1,.628.628v1.883a.628.628,0,0,1-.628.628h3.139a.628.628,0,0,0,.628-.628v-1.883A.628.628,0,0,0,306.013,270.938Zm0,0",
    transform: "translate(-272.114 -243.421)",
    fill: "#bbeded"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10900",
    "data-name": "Path 10900",
    d: "M83.784,340.047c0-3.178-4.919-5.755-10.986-5.755s-10.986,2.576-10.986,5.755S66.73,345.8,72.8,345.8,83.784,343.226,83.784,340.047Zm0,0",
    transform: "translate(-55.534 -300.341)",
    fill: "#ffcd6b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCannedfood);
export default __webpack_public_path__ + "static/media/cannedfood.7b23197a1fec6b8474e26479a1b427d8.svg";
export { ForwardRef as ReactComponent };